import src from "IMAGE";
export default { src, width: 53, height: 66, blurWidth: 0, blurHeight: 0};
